<template>
  <div class="c-no-result">
    <div class="no-result">
      <i class="no-result__icon icon-close-circle"/>

      <span class="no-result__title">
        متاسفانه جستجوی شما در تاریخ مورد نظر نتیجه‌ای نداشت.
      </span>

      <span class="no-result__description">
        لطفا برای نمایش جدیدترین اطلاعات و قیمت‌ها دوباره جستجو کنید
      </span>

      <button
        class="no-result__btn btn btn--primary"
        title="جستجوی مجدد"
        @click="reLoad"
      >
        جستجوی مجدد
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    reLoad() {
      document.location.reload(true);
    },
  },
};
</script>
